// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { listByStorageAccount } from "./operations.js";
export type { PrivateLinkResourcesListByStorageAccountOptionalParams } from "./options.js";
